import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import moment from 'moment';

import calendarReducer from './reducers/calendar.reducer';
import { IEvent } from '../interfaces';
import { CalendarAppText } from './interfaces/calendar-app-text.state';
import calendarSettingsReducer from './reducers/calendar-settings.reducer';
import calendarTextReducer from './reducers/calendar-text.reducer';
import { receiveText } from './actions/calendar-text.actions';
import lazyLoadReducer from './reducers/lazy-load.reducer';
import { ILazyLoadState } from './interfaces/lazy-load.state';
import { ICalendarState } from './interfaces/calendar.state';
import { ICalendarSettings, defaultCalendarSettings } from './interfaces/calendar-settings';
import { setToGrid, setToList, updateCalendarSettings } from './actions/calendar-settings.actions';

declare const lastDate: string;
declare const pageData: string;
declare const promoCode: string;
const lastDateMoment = moment(lastDate);

export interface ICalendarAppState {
    calendar: ICalendarState<IEvent>;
    calendarSettings: ICalendarSettings;
    calendarText: CalendarAppText;
    lazyLoad: ILazyLoadState;
}

const appReducer = combineReducers({
    calendar: calendarReducer,
    calendarSettings: calendarSettingsReducer,
    calendarText: calendarTextReducer,
    lazyLoad: lazyLoadReducer
});

// Calculate the months that are valid on the calendar.
let monthsOnCalendar: moment.Moment[] = [];

for (let i = moment().clone().startOf("month"); i.isSameOrBefore(lastDateMoment.endOf("month")); i.add(1, "month")) {
    monthsOnCalendar.push(i.clone());
}

let calendarSettings = {
    ...defaultCalendarSettings,
    monthsOnCalendar: monthsOnCalendar
};

const appStore = createStore(appReducer, {
    calendarSettings: calendarSettings as any
}, applyMiddleware(thunk));

// redux-thunk messes with redux typings.
appStore.dispatch(receiveText(pageData as any));
console.log((pageData as any).defaultToListViewString);

const calendarEntry = document.getElementById("calendar-entry-js");
let mobileWidth = calendarEntry ? calendarEntry.getAttribute("data-calendar-breakpoint") : "48em";

if ((pageData as any) != null && (((pageData as any).defaultToListViewString == "True" || (pageData as any).defaultToListViewString == "true") || window.innerWidth < Number(mobileWidth)))
    appStore.dispatch(setToList());
else
    appStore.dispatch(setToGrid());


/*appStore.dispatch(updateCalendarSettings(JSON.parse(promoCode)) as any);*/

export { appStore };